"use strict";
import React from "react";
import _ from "underscore";
import Api from "../api/api";
import ApiService from "../services/api_service";
import DataStoreService from "./data_store_service";
import DisablingButton from "./disabling_button";
import "../services/email_service";
import fetch from "../util/fetch";
import reactUtils from "../react_utils";
import "../components/waiting_spinner";
var bem = reactUtils.makeBem("email-label-editor");
export default React.createClass({
  getInitialState: function() {
    return {
      addingLabel: false,
      email: this.props.email,
      saving: false,
      label: null,
      labelErrorMessage: null
    };
  },
  componentDidMount: function() {
    if (!_.isEmpty(this.availableLabels())) {
      this.setState({
        label: this.availableLabels()[0].name || this.availableLabels()[0]
      });
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.labelsList(), this.possibleNewLabelArea(), this.addLabelLink());
  },
  labelsList: function() {
    const labels = _.map(this.state.email.labels, this.labelDisplay);
    if (!_.isEmpty(labels)) {
      return /* @__PURE__ */ React.createElement("div", { className: bem("__labels-list") }, labels);
    }
  },
  labelDisplay: function(label) {
    const labelName = label["name"] || label;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: labelName,
        className: "carrier-labels__label " + bem("__label-display")
      },
      this.labelDisplayContent(labelName)
    );
  },
  labelDisplayContent: function(labelName) {
    if (this.state.saving) {
      return "saving....";
    } else {
      return /* @__PURE__ */ React.createElement("div", null, this.labelDeleteLink(labelName), labelName);
    }
  },
  labelDeleteLink: function(labelName) {
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        onClick: (e) => {
          this.sendData(e, labelName);
        }
      },
      /* @__PURE__ */ React.createElement("i", { className: "fi-x-circle" })
    );
  },
  sendData: function(e, name) {
    e.preventDefault();
    this.setState({ saving: true });
    ApiService.addErrorHandler(
      fetch("/api/email_messages/" + this.state.email.id + "/labels", {
        data: { label_name: name || this.state.label },
        method: name ? "DELETE" : "POST"
      }),
      null,
      { caller: "EmailLabelEditor.sendData" }
    ).then((data) => {
      if (data.error) {
        this.setState({ saving: false, labelErrorMessage: data.error });
      } else {
        this.setState({ email: data.email_messages[0] });
        DataStoreService.updateStores(data);
        this.stopAddingLabel();
        this.setState({
          saving: false,
          label: this.availableLabels()[0].name
        });
      }
    }).catch((data) => {
      this.setState({ saving: false });
    });
  },
  availableLabels() {
    const accountLabels = Api.Account.current().labels;
    const available = _.reject(accountLabels, (al) => {
      _.some(
        this.state.email.labels,
        (l) => al.name === l || al.name === l.name
      );
    });
    return _.sortBy(available, (l) => l.name);
  },
  possibleNewLabelArea: function() {
    if (this.state.addingLabel) {
      if (_.isEmpty(this.availableLabels())) {
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert-box highlight " + bem("__all-labels-added-alert")
          },
          "All available labels have been added.",
          /* @__PURE__ */ React.createElement("a", { className: "close", onClick: this.stopAddingLabel }, "\xD7")
        );
      } else {
        return /* @__PURE__ */ React.createElement("div", { className: bem("__new-label-container") }, this.newLabelSelect(), this.newLabelSaveButton(), this.newLabelCloseButton());
      }
    }
  },
  addLabelLink: function() {
    if (!this.state.addingLabel) {
      return /* @__PURE__ */ React.createElement("div", { className: bem("__add-label-icon") }, /* @__PURE__ */ React.createElement("a", { onClick: this.startAddingLabel }, /* @__PURE__ */ React.createElement("i", { className: "fi-plus" }), "\xA0Add Label"));
    }
  },
  stopAddingLabel: function() {
    this.setState({ addingLabel: false });
  },
  startAddingLabel: function() {
    this.setState({ addingLabel: true });
  },
  labelOption: function(label) {
    return /* @__PURE__ */ React.createElement("option", { value: label.name, key: "label-" + label.name }, label.name);
  },
  newLabelSelect: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__new-label-select") }, /* @__PURE__ */ React.createElement(
      "select",
      {
        value: this.state.label || "",
        onChange: (e) => this.setState({ label: e.target.value })
      },
      _.map(this.availableLabels(), this.labelOption)
    ));
  },
  newLabelCloseButton: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__close-button") }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        className: "button--cancel",
        disabled: this.state.saving,
        disabledText: "Cancel",
        onClick: this.stopAddingLabel
      },
      "Cancel"
    ));
  },
  newLabelSaveButton: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "button--confirmation--container" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        className: "button--confirmation",
        disabled: this.state.saving,
        disabledText: "Saving....",
        onClick: (e) => {
          this.sendData(e, "");
        }
      },
      "Add"
    ));
  }
});
